import React from 'react';
import './styles.css';
import { useRouteMatch, useHistory } from 'react-router-dom';
import DefaultResourceImage from '@BUP/assets/Images/Resources/default_resource.png';
import { useTranslation } from 'react-i18next';

const ResourceElement = ({ resource }) => {
  const history = useHistory();
  const match = useRouteMatch();
  const [t] = useTranslation();

  return (
    <div
      className="resource-element-container"
      aria-hidden
      role="link"
      onClick={() => history.push(`${match.path}/${resource?.id}`)}
      style={{
        backgroundImage: `url(${resource.imgUrl || DefaultResourceImage})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="resource-name">
        <h2>{resource?.name || t('pages.resources.pageNameText2')}</h2>
      </div>
    </div>
  );
};

export default ResourceElement;
